/** DevOps tag that marks a request as a new feature (vs. a bug or chore). */
export const FEATURE_TAG = 'Feature';

/** Exact-tag match, tolerant of the casing/whitespace people type into DevOps. */
export function isFeature(tags: string[]): boolean {
  return tags.some(t => t.trim().toLowerCase() === FEATURE_TAG.toLowerCase());
}
